export default {
    menu_account_notifications_title: "Notificaciones",
    menu_account_notifications_export: "Archivo de exportación",
    menu_account_notifications_export_message: "Clic para descargar el archivo exportado",
    menu_account_notifications_mark_as_read: "Marcar como leído",
    menu_account_notifications_file_generated: "El archivo de exportación ha sido generado y está disponible en la sección de notificaciones",
    menu_account_export_pending_label: "Generando exportación",
    menu_account_export_complete_label: "Exportación lista",
    menu_account_export_expired_label: "La exportación expiró. Por favor intente de nuevo.",
    menu_account_export_download: "Descargar",
    menu_account_export_copy_link: "Copiar enlace",
    menu_account_export_copied: "¡Copiado!",
    menu_account_export_dismiss: "Descartar",
    menu_account_export_elapsed: "Tiempo transcurrido",
    menu_account_export_expires_in: "Expira en",
};